import gql from 'graphql-tag';

const getTagCountsForOrganisationQuery = gql`
  query GetTagCountsForOrganisation(
    $organisationId: ID!,
    $resourceType: ResourceType!,
    $tagType: TagType
  ) {
    getTagCountsForOrganisation(
      organisationId: $organisationId,
      resourceType: $resourceType,
      tagType: $tagType
    ) {
      tagId
      label
      color
      tagType
      resourceType
      count
    }
  }
`;

export default ((organisationId) => ({
  query: getTagCountsForOrganisationQuery,
  module: 'tags',
  ignoreCache: true,
  buildVariables: () => ({
    organisationId,
    resourceType: 'ASSET'
  })
}));